export default "__VITE_ASSET__NZZEpKAu__"